import { useMemo } from 'react';
import chest from '~/assets/icons/chest.svg';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import {
	TechTuningCaseType,
	TechTuningCategory,
	TechTuningRarity,
} from '~/shared';
import { CaseItemColor } from '../CaseItemColor';
import { TuningShopRarityGradientColors } from '../ItemColor';
import { sortItemsByColorAndCategory } from './CaseItemList.model';
import {
	StyledContainer,
	StyledItemsList,
	StyledTitle,
} from './CaseItemList.styled';

const CaseItemList = ({ type }: { type: TechTuningCaseType }) => {
	const caseItems = useObservable(rage.techTuning.getCaseItems(type));

	const itemList = useMemo(() => {
		const mappedItems = caseItems.filter(Boolean).map((item) => ({
			id: item?.id,
			category: item?.category,
			name: item?.name,
			properties: item?.properties,
			imageBg:
				TuningShopRarityGradientColors[item?.rarity ?? TechTuningRarity.COMMON],
		}));

		return sortItemsByColorAndCategory(mappedItems);
	}, [caseItems]);

	return (
		<StyledContainer>
			<StyledTitle>
				<img src={chest} />
				<Text>Содержимое кейса</Text>
			</StyledTitle>
			<StyledItemsList>
				{itemList.map((item, index) => (
					<CaseItemColor
						category={item.category ?? TechTuningCategory.ENGINE}
						name={item.name ?? ''}
						properties={item.properties ?? undefined}
						color={
							item.imageBg ||
							TuningShopRarityGradientColors[TechTuningRarity.COMMON]
						}
						key={index}
					/>
				))}
			</StyledItemsList>
		</StyledContainer>
	);
};

export { CaseItemList };
